import { Dropdown, Empty, Form, Menu, message, Tag } from 'antd'
import { inject, observer } from 'mobx-react'
import React, { useEffect, useMemo, useState } from 'react'
import { Helmet } from 'react-helmet/es/Helmet'
import ContentBlockWrapper from '../../components/ContentBlockWrapper'
import NormalTag from '../../components/NormalTag/NormalTag'
import PageTitle from '../../components/PageTitle'
import {
  BlockLeft,
  BlockRight,
  DocumentContentWrapper,
  HeadingButtonWrapper,
} from './SameDocumentIncomingDocDetailPageStyled'
// PDF Viewer
import {
  CalendarOutlined,
  InboxOutlined,
  MoreOutlined,
  ProfileOutlined,
  ReloadOutlined,
} from '@ant-design/icons'
import moment from 'moment'
import { useMediaQuery } from 'react-responsive'
import { blue } from '../../color'
import {
  EmptyText,
  TitleContentBox,
  WordBreak,
} from '../../components/Common/CellText'
import FileItem from '../../components/Common/FileItemComponent/FileItem'
import PDFViewer from '../../components/PDFViewer/PDFViewer'
import { systemName } from '../../config'
import {
  ACL_ACTION_TYPE,
  DATE_FORMAT_DEFAULT,
} from '../../constants'
import DashboardLayout from '../../layouts/DashboardLayout/DashboardLayout'
import utils from '../../utils'
import InternalDocumentComment from '../Documents/InternalDocumentComment'

const parseNames = input => {
  if (!input) return []
  const list = Array.isArray(input) ? input : [input]
  return list
    .filter(item => typeof item === 'string' && item.trim())
    .reduce((acc, curr) => acc.concat(curr.split(/[,;\n]+/)), [])
    .map(name => utils.getNameInCapitalize(name))
    .filter(Boolean)
}

const SameDocumentIncomingDocDetailPage = props => {
  const [form] = Form.useForm()

  const {
    match,
    commonStore,
    loadingAnimationStore,
    sameDocumentStore,
    connectedDocumentStore,
    aclStore,
  } = props

  const { documentCode } = match.params
  const [document, setDocument] = useState(null)
  const [attachmentForView, setAttachmentForView] = useState()

  const isTabletOrMobile = useMediaQuery({
    query: '(max-width: 1299px)',
  })

  const {
    attachments,
    documentNumber,
    incomingNumber,
    incoming_number,
    authorityIssuedName,
    dateIssued,
    date_issued,
    incomingDate,
    incoming_date,
    signer,
    leader,
    handler,
    coordinator,
    startDate,
    endDate,
    start_date,
    end_date,
    status,
    title,
    sameDocumentCode,
  } = document || {}

  const documentIncomingNumber = incomingNumber || incoming_number
  const documentDateIssued = dateIssued || date_issued
  const documentIncomingDate = incomingDate || incoming_date
  const documentStartDate = startDate || start_date
  const documentEndDate = endDate || end_date

  const leaderList = parseNames(leader)
  const handlerList = parseNames(handler)
  const coordinatorList = parseNames(coordinator)

  useEffect(() => {
    sameDocumentStore.setDataSameDocument({})
    connectedDocumentStore.setDataReceiveDocument({})
  }, [])

  useEffect(() => {
    window.scrollTo(0, 0)
    const contentWrapper =
      window.document?.querySelector('.mainContentWrapper') ||
      window.document?.querySelector('[class*="mainContentWrapper"]')
    if (contentWrapper) {
      contentWrapper.scrollTop = 0
    }
    fetchData()
    return () => {
      form.resetFields()
    }
  }, [documentCode])

  const fetchData = () => {
    loadingAnimationStore.showSpinner(true)
    sameDocumentStore
      .getDocumentsIncomingById(documentCode)
      .then(response => {
        setDocument(response.data)
      })
      .catch(err => {
        props.history.push('/same-document/incoming-document')
        console.log(err)
        message.error(err?.vi || 'Đã có lỗi xảy ra!')
      })
      .finally(() => loadingAnimationStore.showSpinner(false))
  }

  const reloadIncoming = () => {
    sameDocumentStore
      .reloadIncoming({ code: sameDocumentCode })
      .then(response => {
        fetchData()
      })
      .catch(err => {
        console.log(err)
        message.error(err?.vi || 'Đã có lỗi xảy ra!')
      })
      .finally(() => loadingAnimationStore.showSpinner(false))
  }

  useEffect(() => {
    if (!attachments) return
    setAttachmentForView(
      attachments.find(file =>
        ['pdf', 'doc', 'docx'].includes(utils.getExtensionFile(file.fileName))
      )
    )
  }, [attachments])

  const renderAttachmentFile = useMemo(() => {
    if (!attachmentForView?.fileId && !attachmentForView?.file) {
      return (
        <div
          style={{
            background: '#ffffff',
            boxShadow: '0 2px 10px rgba(0, 0, 0, 0.05)',
            borderRadius: 10,
            minHeight: '89vh',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            textAlign: 'center',
          }}>
          <Empty
            description={
              <span style={{ color: '#8c8c8c' }}>
                Không có văn bản đính kèm để xem trước
              </span>
            }
          />
        </div>
      )
    }

    return (
      <PDFViewer
        fileId={attachmentForView?.fileId}
        fileName={attachmentForView?.fileName}
        file={undefined}
        customStyleObj={{ height: isTabletOrMobile ? 500 : 1000 }}
        fileType={utils.getExtensionFile(attachmentForView?.fileName)}
      />
    )
  }, [attachmentForView, isTabletOrMobile])

  const handleClickProcessDocument = () => {
    if (document && document.attachments && document.attachments.length > 0) {
      document.attachments.forEach(file => {
        file.name = file.fileName
      })
    }
    sameDocumentStore.setDataSameDocument(document)
    loadingAnimationStore.showSpinner(true)
    sameDocumentStore
      .updateReceivedStatus({ code: documentCode, status: 'COMPLETED' })
      .then(() => {
        message.success('Đã xử lý văn bản!')
      })
      .catch(error => {
        console.log(error)
        message.error(error.vi)
      })
      .finally(() => {
        loadingAnimationStore.showSpinner(false)
      })
    props.history.push('/internal-document/incoming-document/create')
  }

  const documentHandleDropdown = (
    <Menu>
      {status == 'NEW' &&
        aclStore.checkAccessControlAction(
          ACL_ACTION_TYPE.receive__SAME_DOCUMENT
        ) && (
          <Menu.Item
            icon={<InboxOutlined style={{ color: blue }} />}
            onClick={() => handleReceived()}>
            <span style={{ color: blue }}>Nhận văn bản</span>
          </Menu.Item>
        )}
      {aclStore.checkAccessControlAction(
        ACL_ACTION_TYPE.nap_lai__SAME_DOCUMENT
      ) && (
        <Menu.Item
          icon={<ReloadOutlined style={{ color: blue }} />}
          onClick={reloadIncoming}>
          <span style={{ color: blue }}>Nạp lại văn bản</span>
        </Menu.Item>
      )}
      {aclStore.checkAccessControlAction(
        ACL_ACTION_TYPE.xuly__SAME_DOCUMENT
      ) && (
        <Menu.Item
          icon={<ProfileOutlined style={{ color: blue }} />}
          onClick={handleClickProcessDocument}>
          <span style={{ color: blue }}>Xử lý văn bản</span>
        </Menu.Item>
      )}
    </Menu>
  )

  const handleReceived = () => {
    loadingAnimationStore.showSpinner(true)
    sameDocumentStore
      .updateReceivedStatus({ code: documentCode, status: 'ACCEPT' })
      .then(() => {
        message.success('Nhận văn bản thành công!')
        fetchData()
      })
      .catch(error => {
        console.log(error)
        message.error(error.vi)
      })
      .finally(() => {
        loadingAnimationStore.showSpinner(false)
      })
  }

  return (
    <DashboardLayout>
      <Helmet>
        <title>{`${title} | ${systemName} Quản lý VB nội bộ`}</title>
      </Helmet>

      <PageTitle
        location={props.location}
        title={title ? title : 'Undefined'}
        showTitle={true}
        color={commonStore.appTheme.solidColor}>
        <HeadingButtonWrapper>
          <Dropdown overlay={documentHandleDropdown} trigger={['click']}>
            <span className={'btn-style'}>
              <MoreOutlined />
            </span>
          </Dropdown>
        </HeadingButtonWrapper>
      </PageTitle>
      <DocumentContentWrapper>
        <BlockLeft>{renderAttachmentFile}</BlockLeft>

        <BlockRight>
          {/* 1. Thông tin chung */}
          <ContentBlockWrapper style={{ marginBottom: 16 }}>
            <TitleContentBox>Thông tin chung</TitleContentBox>
            <div style={{ marginTop: 8 }}>
              <div style={{ display: 'flex', padding: '10px 0', borderBottom: '1px solid #ebebeb' }}>
                <div style={{ width: 140, fontWeight: 600, color: '#333', flexShrink: 0 }}>Số hiệu:</div>
                <div style={{ flex: 1, color: '#333', wordBreak: 'break-word' }}>
                  {documentNumber || <span style={{ color: '#aaa', fontStyle: 'italic' }}>Không có số hiệu.</span>}
                </div>
              </div>

              <div style={{ display: 'flex', padding: '10px 0', borderBottom: '1px solid #ebebeb' }}>
                <div style={{ width: 140, fontWeight: 600, color: '#333', flexShrink: 0 }}>Số đến:</div>
                <div style={{ flex: 1, color: '#333', wordBreak: 'break-word' }}>
                  {documentIncomingNumber || <span style={{ color: '#aaa', fontStyle: 'italic' }}>Không có số đến.</span>}
                </div>
              </div>

              <div style={{ display: 'flex', padding: '10px 0', borderBottom: '1px solid #ebebeb' }}>
                <div style={{ width: 140, fontWeight: 600, color: '#333', flexShrink: 0 }}>Ngày ban hành:</div>
                <div style={{ flex: 1, color: '#333', wordBreak: 'break-word' }}>
                  {documentDateIssued ? (
                    <>
                      <CalendarOutlined style={{ color: blue, marginRight: 6 }} />
                      <span>{moment(documentDateIssued).format(DATE_FORMAT_DEFAULT)}</span>
                    </>
                  ) : (
                    <span style={{ color: '#aaa', fontStyle: 'italic' }}>Không có ngày ban hành.</span>
                  )}
                </div>
              </div>

              <div style={{ display: 'flex', padding: '10px 0', borderBottom: '1px solid #ebebeb' }}>
                <div style={{ width: 140, fontWeight: 600, color: '#333', flexShrink: 0 }}>Ngày đến:</div>
                <div style={{ flex: 1, color: '#333', wordBreak: 'break-word' }}>
                  {documentIncomingDate ? (
                    <>
                      <CalendarOutlined style={{ color: blue, marginRight: 6 }} />
                      <span>{moment(documentIncomingDate).format(DATE_FORMAT_DEFAULT)}</span>
                    </>
                  ) : (
                    <span style={{ color: '#aaa', fontStyle: 'italic' }}>Không rõ ngày đến.</span>
                  )}
                </div>
              </div>

              <div style={{ display: 'flex', padding: '10px 0', borderBottom: '1px solid #ebebeb' }}>
                <div style={{ width: 140, fontWeight: 600, color: '#333', flexShrink: 0 }}>Người ký:</div>
                <div style={{ flex: 1, color: '#333', wordBreak: 'break-word' }}>
                  {signer ? (
                    utils.getNameInCapitalize(signer)
                  ) : (
                    <span style={{ color: '#aaa', fontStyle: 'italic' }}>Không có người ký.</span>
                  )}
                </div>
              </div>

              <div style={{ display: 'flex', padding: '10px 0', borderBottom: '1px solid #ebebeb' }}>
                <div style={{ width: 140, fontWeight: 600, color: '#333', flexShrink: 0 }}>Cơ quan ban hành:</div>
                <div style={{ flex: 1, color: '#333', wordBreak: 'break-word' }}>
                  {authorityIssuedName ? WordBreak(authorityIssuedName) : <span style={{ color: '#aaa', fontStyle: 'italic' }}>Không có.</span>}
                </div>
              </div>

              <div style={{ display: 'flex', padding: '10px 0' }}>
                <div style={{ width: 140, fontWeight: 600, color: '#333', flexShrink: 0 }}>Tài liệu đính kèm:</div>
                <div style={{ flex: 1, maxHeight: 150, overflowY: 'auto', paddingRight: 4 }}>
                  {attachments && attachments.length > 0 ? (
                    attachments.map(file => (
                      <FileItem
                        key={file.fileId || file.id}
                        file_id={file.fileId || file.id}
                        file_name={file.fileName || file.name}
                        file_type={utils.getExtensionFile(file.fileName || file.name)}
                      />
                    ))
                  ) : (
                    <EmptyText>Không có tài liệu đính kèm.</EmptyText>
                  )}
                </div>
              </div>
            </div>
          </ContentBlockWrapper>

          {/* 2. Ý kiến */}
          <ContentBlockWrapper style={{ marginBottom: 16 }}>
            <TitleContentBox>Ý kiến</TitleContentBox>
            <div style={{ marginTop: 8, position: 'relative' }}>
              <InternalDocumentComment
                documentId={sameDocumentCode || documentCode}
                readOnly={true}
                setIsLoadingComment={() => {}}
              />
            </div>
          </ContentBlockWrapper>

          {/* 3. Xử lý văn bản */}
          <ContentBlockWrapper style={{ marginBottom: 16 }}>
            <TitleContentBox>Xử lý văn bản</TitleContentBox>
            <div style={{ marginTop: 8 }}>
              <div style={{ display: 'flex', padding: '10px 0', borderBottom: '1px solid #ebebeb' }}>
                <div style={{ width: 140, fontWeight: 600, color: '#333', flexShrink: 0 }}>Lãnh đạo xử lý:</div>
                <div style={{ flex: 1, display: 'flex', flexWrap: 'wrap', gap: 6 }}>
                  {leaderList.length > 0 ? (
                    leaderList.map((name, index) => (
                      <Tag
                        key={`${name}-${index}`}
                        color="blue"
                        style={{
                          borderRadius: 6,
                          margin: 0,
                          fontSize: 13,
                        }}>
                        {name}
                      </Tag>
                    ))
                  ) : (
                    <span style={{ color: '#aaa', fontStyle: 'italic' }}>Không có.</span>
                  )}
                </div>
              </div>

              <div style={{ display: 'flex', padding: '10px 0', borderBottom: '1px solid #ebebeb' }}>
                <div style={{ width: 140, fontWeight: 600, color: '#333', flexShrink: 0 }}>Người xử lý:</div>
                <div style={{ flex: 1, display: 'flex', flexWrap: 'wrap', gap: 6 }}>
                  {handlerList.length > 0 ? (
                    handlerList.map((name, index) => (
                      <Tag
                        key={`${name}-${index}`}
                        color="blue"
                        style={{
                          borderRadius: 6,
                          margin: 0,
                          fontSize: 13,
                        }}>
                        {name}
                      </Tag>
                    ))
                  ) : (
                    <span style={{ color: '#aaa', fontStyle: 'italic' }}>Không có.</span>
                  )}
                </div>
              </div>

              <div style={{ display: 'flex', padding: '10px 0', borderBottom: '1px solid #ebebeb' }}>
                <div style={{ width: 140, fontWeight: 600, color: '#333', flexShrink: 0 }}>Phối hợp/ Theo dõi:</div>
                <div style={{ flex: 1 }}>
                  {coordinatorList.length > 0 ? (
                    <NormalTag
                      tags={coordinatorList}
                      modalTitle="Danh sách người phối hợp / theo dõi"
                    />
                  ) : (
                    <span style={{ color: '#aaa', fontStyle: 'italic' }}>Không có.</span>
                  )}
                </div>
              </div>

              <div style={{ display: 'flex', padding: '10px 0', borderBottom: '1px solid #ebebeb' }}>
                <div style={{ width: 140, fontWeight: 600, color: '#333', flexShrink: 0 }}>Ngày bắt đầu:</div>
                <div style={{ flex: 1, color: '#333', wordBreak: 'break-word' }}>
                  {documentStartDate ? (
                    <>
                      <CalendarOutlined style={{ color: blue, marginRight: 6 }} />
                      <span>{moment(documentStartDate).format(DATE_FORMAT_DEFAULT)}</span>
                    </>
                  ) : (
                    <span style={{ color: '#aaa', fontStyle: 'italic' }}>Không rõ.</span>
                  )}
                </div>
              </div>

              <div style={{ display: 'flex', padding: '10px 0' }}>
                <div style={{ width: 140, fontWeight: 600, color: '#333', flexShrink: 0 }}>Ngày kết thúc:</div>
                <div style={{ flex: 1, color: '#333', wordBreak: 'break-word' }}>
                  {documentEndDate ? (
                    <>
                      <CalendarOutlined style={{ color: blue, marginRight: 6 }} />
                      <span>{moment(documentEndDate).format(DATE_FORMAT_DEFAULT)}</span>
                    </>
                  ) : (
                    <span style={{ color: '#aaa', fontStyle: 'italic' }}>Không rõ.</span>
                  )}
                </div>
              </div>
            </div>
          </ContentBlockWrapper>
        </BlockRight>
      </DocumentContentWrapper>
    </DashboardLayout>
  )
}

SameDocumentIncomingDocDetailPage.propTypes = {}

export default inject(
  'commonStore',
  'sameDocumentStore',
  'loadingAnimationStore',
  'authenticationStore',
  'connectedDocumentStore',
  'aclStore'
)(observer(SameDocumentIncomingDocDetailPage))
